import React from "react";
import { useHintDismiss } from "@/hooks/useHintDismiss";
import { Toggle } from "@/components/Toggle";

export default function FeatureHintsPanel() {
  const { reset, globalSuppress, setGlobalSuppress, dismissedCount } = useHintDismiss();

  return (
    <div className="max-w-2xl">
      <div className="text-lg font-semibold mb-1">Feature tips</div>
      <div className="text-sm text-slate-600 mb-4">
        Velaro surfaces small tips across the product when a feature you already pay for could do more —
        for example, "This integration supports Quick Ticket, enable it in the chat designer."
        You can dismiss tips individually, or turn them off entirely here.
      </div>

      <div className="panel bg-white rounded-2xl shadow-md border p-5 space-y-5">
        <div className="flex items-center justify-between gap-4">
          <div>
            <div className="text-sm font-medium">Never show feature tips</div>
            <div className="text-xs text-slate-500">Hides all contextual tip banners across admin.</div>
          </div>
          <Toggle toggled={globalSuppress} changeToggle={() => setGlobalSuppress(!globalSuppress)} />
        </div>

        <div className="border-t border-slate-100" />

        <div className="flex items-center justify-between gap-4">
          <div>
            <div className="text-sm font-medium">Reset dismissed tips</div>
            <div className="text-xs text-slate-500">
              {dismissedCount > 0
                ? `${dismissedCount} tip${dismissedCount === 1 ? "" : "s"} currently dismissed. Reset to show them again.`
                : "No tips are currently dismissed."}
            </div>
          </div>
          <button
            onClick={reset}
            disabled={dismissedCount === 0}
            className="text-sm px-3 py-1.5 rounded-lg border border-slate-300 text-slate-700 hover:bg-slate-50 disabled:opacity-40 disabled:cursor-not-allowed"
          >
            Reset all
          </button>
        </div>
      </div>
    </div>
  );
}
